import '../../../dashboard/dashboard-reset.css';

type ScheduleVisitModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSchedule: () => void;
  labName?: string;
};

export function ScheduleVisitModal({
  isOpen,
  onClose,
  onSchedule,
  labName = 'Quest Diagnostics',
}: ScheduleVisitModalProps) {
  if (!isOpen) return null;

  return (
    <div className="dashboard-reset fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal Content */}
      <div className="relative mx-4 w-full max-w-[349px] rounded-lg border border-gray-200 bg-white p-5 shadow-xl lg:max-w-[603px] lg:p-10">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full text-gray-600 transition-colors hover:bg-gray-100"
          aria-label="Close modal"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Header */}
        <h2 className="mb-6 text-[25px] font-semibold text-gray-900">
          Schedule Your Lab Visit
        </h2>

        {/* Body */}
        <div className="flex flex-col gap-4">
          {/* Redirect Message */}
          <div className="flex items-center gap-3">
            <svg
              className="h-6 w-6 shrink-0 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
            <p className="text-[22px] leading-[1.5] text-gray-900">
              You'll be redirected to the {labName} website to schedule your lab appointment.
            </p>
          </div>

          {/* Info Box */}
          <div className="rounded-lg bg-gray-50 p-4">
            <ul className="list-disc space-y-3 pl-5 text-[16px] leading-[1.5] text-gray-900">
              <li>
                Your Catch lab visit is already paid for — you won't need to provide payment or insurance
                information.
              </li>
              <li>
                Scheduling is optional — you may also walk in at your selected location during business hours.
              </li>
              <li>
                Catch will not be notified of any appointments, reschedules, or cancellations made on the {labName}
                site.
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="mt-6 flex flex-col-reverse gap-4 lg:flex-row">
          <button
            onClick={onClose}
            className="flex h-10 w-full items-center justify-center rounded-full border-2 border-black bg-white px-6 text-[14px] font-semibold text-black transition-colors hover:bg-gray-50 lg:w-1/2"
          >
            Cancel
          </button>
          <button
            onClick={onSchedule}
            className="flex h-10 w-full items-center justify-center rounded-full bg-[#183344] px-6 text-[14px] font-semibold text-white transition-colors hover:bg-[#0f232e] lg:w-1/2"
          >
            Go to {labName}
          </button>
        </div>
      </div>
    </div>
  );
}
